import { IonButton, IonImg } from '@ionic/react';
import React from 'react';
import { RECOMMENDED_TAB } from "../../../utils/constants";
import { FormatText } from '../../../web/pages/Support/FormatTextComponent/formatText';

const Empty: React.FC<any> = (props: any) => {
  const { icon = 'no-search-icon.svg', constantText = '', constantButton = '', constantAddButton = '', handleClick, segmentName } = props;
  return (
    <div className="No-Recommended">
      <img
        alt="logo"
        src={`./assets/icon/${icon}`}
        width="79.01px"
        height="84.59px"
      />
      <div className="recommended-Error">
        <FormatText
          text={constantText}
          dataType={'richText'}
        /></div>
      <div className="SearchLoadBtn">
        <IonButton
          expand="full"
          shape="round"
          onClick={() => handleClick('search')}
          size="large"
          type="submit"
          class="RecommendedSearch"
        >
          <IonImg src="./assets/icon/SearchError.svg" class="load-search" />
          {constantButton}
        </IonButton>
        {segmentName === RECOMMENDED_TAB ? (
          <>
            <div className="recommended-error-btn-p">OR</div>
            <IonButton
              expand="full"
              shape="round"
              onClick={() => handleClick()}
              size="large"
              type="submit"
              class="RecommendedSearch"
            >
              <IonImg src="./assets/images/manage-add-capacity.svg" class="load-search" />
              {constantAddButton}
            </IonButton>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default Empty;